import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CsvExportOptions,
  ExcelExportOptions,
  Table,
  TableColumn,
  TablePreferences,
} from './tableInterface';

export interface TableConfigurationService {
  saveConfig(
    pageId: string,
    tableId: string,
    preferences: TablePreferences,
  ): Observable<void>;
  loadConfig(pageId: string, tableId: string): Observable<unknown>;
}

export const TABLE_CONFIG_SERVICE = new InjectionToken<TableConfigurationService>('TABLE_CONFIG_SERVICE');

export interface CsvExportProvider {
  export(
    dataToExport: any[],
    columnsToExport: TableColumn[],
    table: Table,
    options?: CsvExportOptions,
  ): void;
}

export const CSV_EXPORT_PROVIDER = new InjectionToken<CsvExportProvider>('CSV_EXPORT_PROVIDER');

/** Genera un libro Excel con los datos visibles de la tabla. */
export type ExcelExportProvider = {
  export(
    dataToExport: any[],
    columnsToExport: TableColumn[],
    options?: ExcelExportOptions,
  ): Promise<void>;
};

export const EXCEL_EXPORT_PROVIDER = new InjectionToken<ExcelExportProvider>(
  'EXCEL_EXPORT_PROVIDER',
);
